export default function MainController(
    $rootScope,
    userService,
    l10nService,
    ipCookie,
    themesService,
) {
    'ngInject';

    $rootScope.isAdmin = userService.isAdmin;
    $rootScope.isBooker = userService.isBooker;
    $rootScope.isApprover = userService.isApprover;
    $rootScope.isTripHolder = userService.isTripHolder;
    $rootScope.isFinanceManager = userService.isFinanceManager;
    $rootScope.isStandardUser = userService.isStandardUser;
    $rootScope.isUSRegion = userService.isUSRegion();
    $rootScope.isUKRegion = userService.isUKRegion();
    $rootScope.isBERegion = userService.isBERegion();
    $rootScope.countryCode = userService.getUser().CountryCode;
    $rootScope.l10n = l10nService;
    $rootScope.regionalSettings = userService.getRegionalSettings();

    themesService.applyThemeFromRequest();
}



// WEBPACK FOOTER //
// ./src/app/modules/main/controllers/mainController.js